// extracted by mini-css-extract-plugin
export default {"productInfo":"ProductInfo_productInfo__CuSmn","infoContainer":"ProductInfo_infoContainer__h3MpH"};